export default __webpack_public_path__ + "static/media/Harness of Vengeful Zeal.fdcad7fb.jpg";